module.exports = __webpack_public_path__ + "img/viacom.0e8d8bfa.svg";